import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const MenuContainer = styled.div`
	display: flex;
	align-items: center;
	padding: var(--padding-2);
	width: 100%;
	gap: 1rem;

	@media ${Breakpoints.mobile} {
		padding: var(--padding-4) var(--padding-2);
		flex-wrap: unset;
		justify-content: flex-end;
	}
`;

export const FiltersContainer = styled.div`
	display: flex;
	gap: 1rem;
	flex-wrap: wrap;

	.table-filters-container {
		padding: 0;
	}
`;

export const MobileFilterDot = styled.span`
	display: none;
	position: absolute;
	width: 0.75rem;
	height: 0.75rem;
	border-radius: 50%;
	background-color: var(--red-70);
	right: 0.75rem;
	top: 0.75rem;

	@media ${Breakpoints.mobile} {
		display: block;
	}
`;
